<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-40">
      <departure-summary :tour="this.$route.params.tour_id" />
    </div>
    <div class="md-layout-item md-size-60">
      <departure-tabs :departure="departure" />
    </div>
  </div>
</template>
<script>
import tourApi from "@/services/api/tour";

import DepartureSummary from "./DepartureSummary.vue";
import DepartureTabs from "./DepartureTabs.vue";

export default {
  components: {
    DepartureSummary,
    DepartureTabs
  },

  data() {
    return {};
  },

  methods: {},

  mounted() {},

  computed: {
    departure() {
      return this.$store.state.departures.departure;
    }
  }
};
</script>
